import httpService from "./httpService";
import utils from "./utils";

export default {
  findAllBySenderIdOrReceiverId(objectId, objectType, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { objectId: objectId, objectType: objectType },
      pageable
    );
    return httpService.get("vbComment/findAllBySenderIdOrReceiverId", {
      params: params
    });
  },

  findAllTaskComments(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbComment/findAllTaskComments", { params: params });
  },

  insert(form) {
    return httpService.post("vbComment", form);
  },

  commentForTask(form) {
    return httpService.post("vbComment/commentForTask", form);
  },

  commentForHcCommand(form) {
    return httpService.post("vbComment/commentForHcCommand", form);
  },

  commentForHcCongViecTrongTam(form) {
    return httpService.post("vbComment/commentForHcCongViecTrongTam", form);
  },

  commentForHcQuyCheQuyDinh(form) {
    return httpService.post("vbComment/commentForHcQuyCheQuyDinh", form);
  },

  findAllHcCommandComments(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbComment/findAllHcCommandComments", {
      params: params
    });
  },

  delete(id) {
    return httpService.post(`vbComment/delete/${id}`);
  },

  edit(id,form) {
    return httpService.put(`vbComment/edit/${id}`, form);
  },
};



// WEBPACK FOOTER //
// ./src/services/vbCommentService.js